(function () {
  const imageSelector = '#MainContent img';
  const skipSelector = [
    'button',
    'modal-opener',
    'product-modal',
    '.product__modal-opener',
    '.product-media-modal',
    '.quick-add-modal',
    '.cart-drawer',
    '.cart-notification',
    '.facets',
    '.header',
    '.footer',
    '.shopify-payment-button',
  ].join(',');
  const navigableLinkSelector = 'a[href]';

  let lightbox;
  let lightboxImage;
  let closeButton;
  let lastActiveElement;

  function normalizeImageUrl(url) {
    if (!url) return '';

    try {
      const imageUrl = new URL(url, window.location.href);
      imageUrl.searchParams.delete('width');
      imageUrl.searchParams.delete('height');
      imageUrl.searchParams.delete('crop');
      return imageUrl.toString();
    } catch (error) {
      return url;
    }
  }

  function largestSrcsetCandidate(srcset) {
    if (!srcset) return '';

    return srcset
      .split(',')
      .map((candidate) => {
        const parts = candidate.trim().split(/\s+/);
        const width = parts[1] && parts[1].endsWith('w') ? parseInt(parts[1], 10) : 0;
        return {
          url: parts[0],
          width: Number.isNaN(width) ? 0 : width,
        };
      })
      .filter((candidate) => candidate.url)
      .sort((a, b) => b.width - a.width)[0]?.url || '';
  }

  function imageSource(image) {
    return normalizeImageUrl(image.currentSrc || largestSrcsetCandidate(image.getAttribute('srcset')) || image.src);
  }

  function isEligibleImage(image) {
    if (!image || image.closest(skipSelector)) return false;
    if (image.closest(navigableLinkSelector) && image.dataset.ownartLightbox !== 'true') return false;
    if (image.dataset.ownartLightbox === 'false') return false;
    if (image.getAttribute('role') === 'presentation') return false;
    if (image.closest('[aria-hidden="true"]')) return false;

    const rect = image.getBoundingClientRect();
    const isForced = image.dataset.ownartLightbox === 'true';
    return (isForced || (rect.width >= 160 && rect.height >= 160)) && imageSource(image) !== '';
  }

  function ensureLightbox() {
    if (lightbox) return;

    lightbox = document.createElement('div');
    lightbox.className = 'ownart-image-lightbox';
    lightbox.setAttribute('role', 'dialog');
    lightbox.setAttribute('aria-modal', 'true');
    lightbox.setAttribute('aria-label', 'Image preview');
    lightbox.hidden = true;

    closeButton = document.createElement('button');
    closeButton.type = 'button';
    closeButton.className = 'ownart-image-lightbox__button';
    closeButton.setAttribute('aria-label', 'Close image preview');

    const figure = document.createElement('figure');
    figure.className = 'ownart-image-lightbox__figure';

    lightboxImage = document.createElement('img');
    lightboxImage.className = 'ownart-image-lightbox__image';
    lightboxImage.alt = '';

    figure.appendChild(lightboxImage);
    lightbox.append(closeButton, figure);
    document.body.appendChild(lightbox);

    closeButton.addEventListener('click', closeLightbox);
    lightbox.addEventListener('click', (event) => {
      if (event.target === lightbox) closeLightbox();
    });
  }

  function openLightbox(image) {
    const src = imageSource(image);
    if (!src) return;

    ensureLightbox();
    lastActiveElement = document.activeElement;
    lightboxImage.src = src;
    lightboxImage.alt = image.alt || '';
    lightbox.hidden = false;
    document.body.classList.add('ownart-lightbox-open');

    requestAnimationFrame(() => {
      lightbox.classList.add('is-open');
      closeButton.focus();
    });
  }

  function closeLightbox() {
    if (!lightbox || lightbox.hidden) return;

    lightbox.classList.remove('is-open');
    document.body.classList.remove('ownart-lightbox-open');

    window.setTimeout(() => {
      lightbox.hidden = true;
      lightboxImage.removeAttribute('src');
      if (lastActiveElement && typeof lastActiveElement.focus === 'function') {
        lastActiveElement.focus();
      }
    }, 180);
  }

  function markImages() {
    document.querySelectorAll(imageSelector).forEach((image) => {
      image.classList.toggle('ownart-lightbox-enabled', isEligibleImage(image));
    });
  }

  document.addEventListener('click', (event) => {
    const image = event.target.closest(imageSelector);
    if (!isEligibleImage(image)) return;

    event.preventDefault();
    event.stopPropagation();
    openLightbox(image);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeLightbox();
  });

  document.addEventListener('DOMContentLoaded', markImages);
  document.addEventListener('shopify:section:load', markImages);
  window.addEventListener('load', markImages);
})();
